
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_15100_5155)","fill":"#979797"}},[_c('path',{attrs:{"d":"M21.25 21H2.75A2.752 2.752 0 010 18.25V5.75A2.752 2.752 0 012.75 3h18.5A2.752 2.752 0 0124 5.75v12.5A2.752 2.752 0 0121.25 21zM2.75 4.5c-.689 0-1.25.561-1.25 1.25v12.5c0 .689.561 1.25 1.25 1.25h18.5c.689 0 1.25-.561 1.25-1.25V5.75c0-.689-.561-1.25-1.25-1.25H2.75z"}}),_c('path',{attrs:{"d":"M7.5 12A2.503 2.503 0 015 9.5C5 8.122 6.122 7 7.5 7S10 8.122 10 9.5 8.878 12 7.5 12zm0-3.5c-.551 0-1 .449-1 1 0 .551.449 1 1 1 .55 0 1-.449 1-1 0-.551-.45-1-1-1zM11.25 17a.75.75 0 01-.75-.75v-.5c0-.689-.561-1.25-1.25-1.25h-3.5c-.689 0-1.25.561-1.25 1.25v.5a.75.75 0 01-1.5 0v-.5A2.752 2.752 0 015.75 13h3.5A2.752 2.752 0 0112 15.75v.5a.75.75 0 01-.75.75zM20.25 9h-5.5a.75.75 0 010-1.5h5.5a.75.75 0 010 1.5zM20.25 13h-5.5a.75.75 0 010-1.5h5.5a.75.75 0 010 1.5zM20.25 17h-5.5a.75.75 0 010-1.5h5.5a.75.75 0 010 1.5z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_15100_5155"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    